<template lang="pug">
  div.wrap-module-trainee-calendar
    div.wrap-calendar-header.f.fm
      div(v-if="type === 'month'").header-content.f.fm.flex-between
        div.f.flex-between
          v-icon(@click="prev") mdi-chevron-left
          span.pt1 {{headerLabel}}
          v-icon(@click="next") mdi-chevron-right
        div.selector
          div.selector-component
            v-select(v-model="filterValue" :items="filterList")
      div(v-if="type === 'day'").header-content.f.fm
        v-icon(@click="type = 'month'") mdi-chevron-left
        span.ml4.pt1 {{headerDayLabel}}
    div(:class="{'is-ios-safari': iOSSafari}").wrap-calendar
      v-calendar(
        ref="calendar"
        v-model="value"
        :weekdays="weekday"
        :type="type"
        :events="events"
        :event-overlap-mode="mode"
        :event-overlap-threshold="30"
        :event-color="getEventColor"
        @change='onChangeEvents'
        @click:date="clickDate"
        @click:event="clickEvent")
      div(v-if="$route.name === 'trainer-calendar'" @click="onAddEvent").button-add-event.f.fh.px12.py12
        v-icon(color='#fff') add
</template>

<style lang="scss" scoped>
$header_height: 48px;
$calendar_header_height: 36px;
$safari_toolbar_height: 110px;

.wrap-module-trainee-calendar {
  width: 100%;
  min-height: 100vh;
  padding-top: $header_height;
  .wrap-calendar-header {
    position: fixed;
    top: $header_height;
    width: 100%;
    height: $calendar_header_height;
    z-index: 100;
    background: #fff;
    .header-content {
      width: 93%;
      max-width: 820px;
      margin: 0 auto;
      .selector {
        width: 78px;
        position: relative;
        top: 2px;
      }
    }
  }
  .wrap-calendar {
    position: relative;
    top: $calendar_header_height;
    height: calc(100vh - #{$header_height} - #{$calendar_header_height});
    // &.is-ios-safari {
    //   height: calc(100vh - #{$header_height} - #{$calendar_header_height} - #{$safari_toolbar_height});
    // }
    .button-add-event {
      z-index: 1;
      position: absolute;
      right: 12px;
      bottom: 62px;
      cursor: pointer;
      border-radius: 50%;
      background: #45bad5;
      filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.4));
    }
  }
}
</style>

<style lang="scss">
.wrap-module-trainee-calendar {
  .v-input__control {
    font-size: 14px;
  }
  .v-btn__content {
    color: #2a2a2a;
  }
  .v-input__slot:before {
    display: none;
  }
  .v-input__slot:after {
    display: none;
  }
}
</style>

<script>
import format from "date-fns/format"
import db from "@/components/utils/firebase"
import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth } = createNamespacedHelpers("auth")

export default {
  components: {
  },
  computed: {
    ...mapStateAuth(["uid"]),
    iOSSafari () {
      var ua = window.navigator.userAgent
      var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
      var webkit = !!ua.match(/WebKit/i)
      return iOS && webkit && !ua.match(/CriOS/i)
    }
  },
  data () {
    return {
      clients: [],
      filterValue: "全て",
      filterList: [],

      events: [],
      allEvents: [],
      headerLabel: "",
      headerDayLabel: "",
      now: new Date(),
      type: "month",
      types: ["month", "week", "day", "4day"],
      mode: "stack",
      modes: ["stack", "column"],
      weekday: [0, 1, 2, 3, 4, 5, 6],
      weekdays: [
        { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
        { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] },
        { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
        { text: "Mon, Wed, Fri", value: [1, 3, 5] }
      ],
      value: "",
      colors: ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1"]
    }
  },
  watch: {
    filterValue: function () {
      switch (this.filterValue) {
        case "全て":
          this.events = this.allEvents
        break
        case "担当回":
          this.events = this.allEvents.filter(event => {
            return (event.trainer === this.uid)
          })
        break
        case "参加回":
          this.events = this.allEvents.filter(event => {
            return event.attendee.includes(this.uid)
          })
        break
      }
    }
  },
  created () {
    db.collection("EVENT")
      .onSnapshot(this.initEvent)

    if (this.$route.name === "trainer-calendar") {
      this.filterList = ["全て", "担当回"]
    } else if (this.$route.name === "trainee-calendar") {
      this.filterList = ["全て", "参加回"]
    }
  },
  methods: {
    initEvent (q) {
      let events = q.docs.map(d => {
        let data = d.data()
        data.id = d.id
        return data
      })
      this.allEvents = events.map(e => {
        return {
          id: e.id,
          name: e.title,
          createdBy: e.createdBy,
          attendee: e.attendee,
          trainer: e.trainer,
          color: "blue",
          start: e.startTime.toDate(),
          end: e.endTime.toDate(),
          timed: true
        }
      })
      this.allEvents = this.allEvents.map(event => {
        event.color = (event.trainer === this.uid || event.attendee.includes(this.uid))
           ? "orange" : "blue"
        return event
      })
      this.events = this.allEvents
    },
    onChangeEvents ({ start, end }) {
      this.headerLabel = format(new Date(start.date), "M月")
    },
    clickDate (event, test) {
      console.log("clickDate", event)
      if (this.type === "month") {
        this.type = "day"
        this.headerDayLabel = format(new Date(event.date), "yyyy年M月d日")
      }
    },
    clickEvent (event) {
      console.log("clickEvent", event)
      if (this.$route.name === "trainee-calendar") {
        this.$router.push(`/calendar/${event.event.id}`)
      } else {
        this.$router.push(`/trainer/calendar/${event.event.id}`)
      }
    },
    viewDay (event) {
      console.log("viewDay", event)
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    getEventColor (event) {
      return event.color
    },
    async onAddEvent () {
      // 新しいidを生成
      let id = await db.collection("create_new_id").doc().id
      this.$router.push(`/trainer/calendar/${id}/edit`)
    }
  }
}
</script>
